// Typed mock data for EPIC-001 (Navigate to Mass Update Flow), handover run HR-001.
// Draft only — no API-backed source yet. Each row is a real flow this app hosts;
// the `href` targets now point at the routes built for EPIC-002/005/008/010.

export type MassUpdateFlowId = "sales-orders" | "work-orders" | "import-work-orders" | "jobs";

export interface MassUpdateFlow {
  id: MassUpdateFlowId;
  kicker: string;
  title: string;
  description: string;
  href: string;
}

export const massUpdateFlows: MassUpdateFlow[] = [
  {
    id: "sales-orders",
    kicker: "Sales Orders",
    title: "Mass-update Sales Orders",
    description:
      "Search a batch of existing order lines, set a new status, location, or ship date, and preview the change before it goes out.",
    href: "/dashboard/search-sales-orders",
  },
  {
    id: "work-orders",
    kicker: "Work Orders",
    title: "Mass-update Work Orders",
    description:
      "Search a batch of existing work orders and change their dates, status, firmed flag, location, or memo.",
    href: "/dashboard/search-work-orders",
  },
  {
    id: "import-work-orders",
    kicker: "Import Work Orders",
    title: "Create Work Orders from a spreadsheet",
    description:
      "Upload a CSV of new work orders, fix anything that doesn't match a real item or location, then create them all at once.",
    href: "/dashboard/import-work-orders",
  },
  {
    id: "jobs",
    kicker: "Jobs",
    title: "Watch what's been sent",
    description:
      "Every batch of changes shows up here — queued, in progress, complete, or failed — with the reason if something didn't go through.",
    href: "/dashboard/jobs",
  },
];

export const navigateToMassUpdateFlowKeys = {
  all: ["mocks", "navigate-to-mass-update-flow", "flows"] as const,
};

export function fetchMassUpdateFlows(): Promise<MassUpdateFlow[]> {
  return Promise.resolve(massUpdateFlows);
}
